import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { AddressDocumentExportListWidgetComponent } from '../address-document-export-list-widget/address-document-export-list-widget.component';

@Component({
  selector: 'app-formly-address-document-export-list',
  templateUrl: './formly-address-document-export-list.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [AddressDocumentExportListWidgetComponent]
})
export class FormlyAddressDocumentExportListComponent extends FieldType implements OnInit {

  ngOnInit(): void {
  }
}
